import { Grid, List, ListItem, Typography } from '@mui/material';
import Transaction from '../../../services/transaction/Transaction';
import { useTranslation } from 'react-i18next';
import React from 'react';
import TransactionType from '../../../services/transaction/TransactionType';

interface TransactionListProps {
  transactions: Transaction[];
  transactionTypes: TransactionType[];
}

const TransactionList = ({ transactions, transactionTypes }: TransactionListProps): JSX.Element => {
  const { i18n } = useTranslation('familiplusPage');
  const dateFormatter = new Intl.DateTimeFormat(i18n.language, { day: 'numeric', month: 'long', year: 'numeric' });

  const getTypeLabel = (typeId: number): string => {
    const type = transactionTypes.find((t) => t.Id === typeId);
    if (!type) {
      return '';
    }
    return i18n.language.indexOf('fr') === 0 ? type.FrenchDescription : type.EnglishDescription;
  };

  return (
    <List id="TransactionList" sx={{ borderTop: '1px solid #dfe3e6' }}>
      {transactions.map((transaction, index) => (
        <ListItem key={`${index}_${transaction.Date}`} sx={{ borderBottom: '1px solid #dfe3e6' }}>
          <Grid container>
            <Grid item xs={9}>
              <Grid container>
                <Grid data-cy="TransactionDate" item xs={12} sm={4} sx={{ fontSize: '0.75rem', color: '#668098' }}>
                  {dateFormatter.format(new Date(transaction.Date))}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography
                    data-cy="TransactionType"
                    component="span"
                    sx={{ fontSize: '1rem', fontWeight: 500, color: (theme) => theme.palette.primary.main }}>
                    {getTypeLabel(transaction.TransactionType)}
                  </Typography>
                  <br />
                  <Typography data-cy="MerchantName" component="span" sx={{ fontSize: '0.75rem', color: '#668098' }}>
                    {transaction.MerchantName}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid
              data-cy="NbPoints"
              item
              xs={3}
              sx={{ fontSize: '1rem', fontWeight: 700, color: '#EA0404', textAlign: 'right' }}>
              {transaction.Accumulation ? '+' : '-'}
              &nbsp;{transaction.NbPoints}&nbsp;pts
            </Grid>
          </Grid>
        </ListItem>
      ))}
    </List>
  );
};

export default TransactionList;
